import * as track from 'lib/gaTracking/bookingListPageEvents';
import { CardProps } from '../types';
import { CardWrapper, InfoWrapper, Heading, StayInfo, Hr, ItemLinks } from '../Components';

const CancelledBookingCard = ({ booking, ...rest }: CardProps) => {
  const { links, reservation } = booking;

  const detailsLink = {
    label: 'View details',
    url: links.manage,
    onClick: () => track.viewDetailsLink(booking),
  };

  return (
    <CardWrapper>
      <InfoWrapper bookingId={booking.id} {...rest}>
        <Heading>{reservation.property.name}</Heading>
        <StayInfo booking={booking} />
      </InfoWrapper>

      <Hr />

      <ItemLinks links={[detailsLink]} />
    </CardWrapper>
  );
};

CancelledBookingCard.displayName = 'CancelledBookingCard';

export { CancelledBookingCard };
